// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WebOrganisationModel from '../../model/web-organisation-model';
import WebOrganisationDTO from '../dto/web-organisation-dto';
import dtoSchema from '../schemas/web-organisation-schema';

export default abstract class WebOrganisationModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WebOrganisationDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.name = data.name ?? undefined;
      this.genericName = data.genericName ?? undefined;
      this.website = data.website ?? undefined;
      this.email = data.email ?? undefined;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  name?: string;
  /**
  */
  genericName?: string;
  /**
  */
  website?: string;
  /**
  */
  email?: string;

  static toModel(dto: DeepPartial<WebOrganisationDTO>): WebOrganisationModel;
  static toModel(dto: DeepPartial<WebOrganisationDTO> | undefined | null): WebOrganisationModel | undefined;
  static toModel(dto: DeepPartial<WebOrganisationDTO> | undefined | null): WebOrganisationModel | undefined {
    return dto ? new WebOrganisationModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WebOrganisationModel> | WebOrganisationModel): WebOrganisationDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      name: unwrapped.name,
      genericName: unwrapped.genericName,
      website: unwrapped.website,
      email: unwrapped.email,
    } as WebOrganisationDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WebOrganisationModel, can not map to WebOrganisationDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
